/**
 * The height to reserve for a bar that content must clear.
 *
 * Not `offsetHeight`, which is an integer derived from the element's snapped
 * edges: a bar whose real height is fractional (the reader footer measures
 * 65.39px on a desktop viewport) reports a different `offsetHeight` once its
 * sub-pixel position shifts, and WebKit and Chromium disagree about which
 * integer that is. A reserve published out of a ResizeObserver then goes stale
 * and stays stale, because moving an element fires no resize notification —
 * which is how the footer came to reserve 66px for a 65px box in WebKit while
 * the box itself never changed size.
 *
 * `getBoundingClientRect().height` is the size alone, unaffected by where the
 * element sits, so a resize is the only thing that can change it. Rounded up,
 * because a reserve that is a fraction short lets content under the bar.
 */
export function measureReservedHeight(element) {
    return Math.ceil(element.getBoundingClientRect().height);
}
